<div class="row d-flex justify-content-center mt-2" *ngIf="isLoading">
    <div class="col-xs-10 conference-container" style="height:95vh; padding-top:100px">
        <app-skeleton-loader variant="block" [rows]="6"></app-skeleton-loader>
    </div>
</div>

<!-- For phone screen, interview and recruiter screening -->
<app-audio-video-conference *ngIf="!isLoading && (workflowStep === 'ps' || workflowStep == 'in' || workflowStep == 'rs')"
    [jobMatchObject]="candidateJobMatch"
    [scheduleObject]="scheduleInfo"
    [candidateId]="candidateId"
    [jobId]="jobId"
    [jobMatchId]="jobMatchId"
    [scheduleId]="scheduleId"
    [scheduleInfo]="scheduleInfo"
    [meetingLink]="meetingLink"
    [participantName]="participantName"
    [participantType]="type"
    [workflowStep]="workflowStep"
    [mode]="mode"
    sourceScreen="CANDIDATE_WORKFLOW"
    [formalizeActivityPayload]="formalizeActivityPayload">
</app-audio-video-conference>

<!-- The block below was already dead in the original AngularJS conference.html (commented
     out there too, superseded by app-job-match-profile-on-conference / candidate-profile
     tabset now rendered directly inside app-audio-video-conference's own template), so it
     is preserved here as a comment for fidelity rather than deleted, per the "no behavior
     change" scope for this migration step.

<div class="container mt-2" *ngIf="!isLoading && (mode == 'PHONE' || mode == 'FACE_TO_FACE')">
  <div class="row border-top">
    <div class="col-xs-12">
      <div class="row justify-content-center">
        <h1 class="h3 mb-5 font-weight-normal">
          Candidate Profile
        </h1>
      </div>
      <app-job-match-profile-on-conference *ngIf="!isLoading && context !== 'candidateCard'"
          [workflowStep]="workflowStep"
          [jobMatchId]="jobMatchId"
          [jobId]="jobId"
          [candidateId]="candidateId"
          [scheduleId]="scheduleId"
          [displayAllSchedule]="displayAllSchedule"
          [feedbackUserIdsList]="scheduleInfo?.usersList"
          context="conference">
      </app-job-match-profile-on-conference>

      <tabset *ngIf="!isLoading && context === 'candidateCard'">
        <tab heading="Candidate Profile">
          <candidate-profile
            [candidateId]="candidateId">
          </candidate-profile>
        </tab>
      </tabset>
    </div>
  </div>
</div>
-->
